import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, List, ListItem, Typography } from '@mui/material';

import Modal from '@components/Modal/Modal';

import './styles.scss';

interface IProps {
  onClose: () => void;
}

const HRSTermsAndConditionsModal: FC<IProps> = ({ onClose }): JSX.Element => {
  const { t } = useTranslation();
  return (
    <Modal
      className="high-risk-supplements-modal"
      onClose={onClose}
      open
      rightActionTitle={t('highRiskSupplements.welcomeModalConfirm')}
      onRightAction={onClose}
      contentClass="high-risk-supplements-modal__content"
    >
      <Box>
        <Typography variant="h2" className="high-risk-supplements-modal__heading">
          {t('highRiskSupplementsTermAndConditions.heading1')}
        </Typography>
        <Typography variant="h3" className="high-risk-supplements-modal__heading">
          {t('highRiskSupplementsTermAndConditions.heading2')}
        </Typography>
        <Box className="high-risk-supplements-modal__block">
          <Typography className="high-risk-supplements-modal__text">
            {t('highRiskSupplementsTermAndConditions.statement1')}
          </Typography>
        </Box>
        <Box className="high-risk-supplements-modal__block">
          <Typography className="high-risk-supplements-modal__text">
            {t('highRiskSupplementsTermAndConditions.statement2')}
          </Typography>
        </Box>
        <Box className="high-risk-supplements-modal__block">
          <Typography className="high-risk-supplements-modal__text">
            {t('highRiskSupplementsTermAndConditions.list1description')}
          </Typography>
          <List className="high-risk-supplements-modal__list">
            <ListItem className="high-risk-supplements-modal__list-item">
              {t('highRiskSupplementsTermAndConditions.list1item1')}
            </ListItem>
            <ListItem className="high-risk-supplements-modal__list-item">
              {t('highRiskSupplementsTermAndConditions.list1item2line1')}
              <br />
              <b>{t('highRiskSupplementsTermAndConditions.andOr')}</b>
              <br />
              {t('highRiskSupplementsTermAndConditions.list1item2line2')}
            </ListItem>
            <ListItem className="high-risk-supplements-modal__list-item">
              {t('highRiskSupplementsTermAndConditions.list1item3')}
            </ListItem>
          </List>
        </Box>
        <Box className="high-risk-supplements-modal__block">
          <Typography className="high-risk-supplements-modal__text">
            {t('highRiskSupplementsTermAndConditions.list2description')}
          </Typography>
          <List className="high-risk-supplements-modal__list">
            <ListItem className="high-risk-supplements-modal__list-item">
              {t('highRiskSupplementsTermAndConditions.list2item1')}
            </ListItem>
            <ListItem className="high-risk-supplements-modal__list-item">
              {t('highRiskSupplementsTermAndConditions.list2item2')}
            </ListItem>

            <ListItem className="high-risk-supplements-modal__list-item">
              {t('highRiskSupplementsTermAndConditions.list2item3')}
            </ListItem>
            <ListItem className="high-risk-supplements-modal__list-item">
              {t('highRiskSupplementsTermAndConditions.list2item4')}
            </ListItem>
          </List>
        </Box>
        <Box className="high-risk-supplements-modal__block">
          <Typography className="high-risk-supplements-modal__text">
            {t('highRiskSupplementsTermAndConditions.statement3')}
          </Typography>
        </Box>
        <Box className="high-risk-supplements-modal__block">
          <Typography className="high-risk-supplements-modal__text">
            {t('highRiskSupplementsTermAndConditions.statement4')}
          </Typography>
        </Box>
        <Box className="high-risk-supplements-modal__block">
          <Typography className="high-risk-supplements-modal__text">
            {t('highRiskSupplementsTermAndConditions.list3description')}
          </Typography>
          <List className="high-risk-supplements-modal__list">
            <ListItem className="high-risk-supplements-modal__list-item">
              {t('highRiskSupplementsTermAndConditions.list3item1')}
            </ListItem>
            <ListItem className="high-risk-supplements-modal__list-item">
              {t('highRiskSupplementsTermAndConditions.list3item2')}
            </ListItem>
            <ListItem className="high-risk-supplements-modal__list-item">
              {t('highRiskSupplementsTermAndConditions.list3item3')}
            </ListItem>
            <ListItem className="high-risk-supplements-modal__list-item">
              {t('highRiskSupplementsTermAndConditions.list3item4')}
            </ListItem>
          </List>
        </Box>
        <Box className="high-risk-supplements-modal__block">
          <Typography className="high-risk-supplements-modal__text">
            {t('highRiskSupplementsTermAndConditions.statement5')}
          </Typography>
        </Box>
        <Box>
          <Typography className="high-risk-supplements-modal__text">
            {t('highRiskSupplementsTermAndConditions.list4description')}
          </Typography>
          <List className="high-risk-supplements-modal__list">
            <ListItem className="high-risk-supplements-modal__list-item">
              {t('highRiskSupplementsTermAndConditions.list4item1')}
            </ListItem>
            <ListItem className="high-risk-supplements-modal__list-item">
              {t('highRiskSupplementsTermAndConditions.list4item2')}
            </ListItem>
          </List>
        </Box>
      </Box>
    </Modal>
  );
};

export default HRSTermsAndConditionsModal;
